import * as Yup from 'yup';

export const validationSchema = Yup.object({
  name: Yup.string().required('Deliverable name is required').max(250, 'Must be less than 250 characters'),
  notes: Yup.string().max(1000, 'Must be less than 1000 characters').nullable(),
  lead: Yup.mixed().required('Lead is required').nonNullable().notOneOf([0], 'Lead is required'),
  vendor: Yup.mixed().nullable().optional(),
  support: Yup.mixed().nullable().optional(),
  startDate: Yup.string().nullable(),
  dueDate: Yup.string().nullable(),
});
